import { FETCH_ALL_EXCLUDED_DOMAINS_SUCCESS } from '../types'

export default function isLoading(state = false, { type }) {
  if (type === FETCH_ALL_EXCLUDED_DOMAINS_SUCCESS) return true
  return state
}
